<template>
  <a-card :bordered="false">
    <register-result :is-success="false" :title="title" :description="description" :content="false">
      <template slot="action">
        <!--<a-button type="primary" @click="scan">扫描二维码</a-button>-->
      </template>
    </register-result>
  </a-card>
</template>

<script>
import RegisterResult from './RegisterResult'

export default {
  components: {
    RegisterResult
  },

  props: {
    description: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      title: '激活失败'
    }
  },

  mounted () {
    // this.startRecognize()
  },

  methods: {
    scan () {
      this.$emit('onScan')
    }
  }
}
</script>

<style scoped>

</style>
